;( function( $, undefined )
{

    $.fn.SiteCatalystThread = function( siteCat )
    {
        var that = siteCat;

        var boardName  = $.fn.SiteCatalyst.globals.thread.boardName;
        var subject    = $.fn.SiteCatalyst.globals.thread.subject;
        var prop20     = $.fn.SiteCatalyst.globals.thread.prop20;
        var baseEvents = [ 66, 43 ];

        // Subscribe to a Thread
        $( '.addThreadUserEmailSubscription' ).click( function()
        {
            if( $( this ).hasClass( 'lia-link-disabled' ) )
            {
                return;
            }

            that.track( 'Subscribe to a thread', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:thread:thread-subscribe:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Subscribe to a message
        $( '.first-message' ).find( '.addMessageUserEmailSubscription' ).click( function()
        {
            if( $( this ).hasClass( 'lia-link-disabled' ) )
            {
                return;
            }

            that.track( 'Subscribe to a message', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:thread:message-subscribe:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        $( '.share' ).on( 'click', 'a', function()
        {
            if( $( this ).hasClass( 'recommend-via-mail' ) || $( this ).hasClass( 'report-abuse-link' ) )
            {
                return;
            }

            var channel = $( this ).attr( 'class' );
            var events  = baseEvents;

            if( channel == 'fb' )
            {
                events.push( 48 );
            }
            else if( channel == 'twitter' )
            {
                events.push( 48 );
            }
            else if( channel == 'gplus' )
            {
                events.push( 48 );
            }
            else
            {
                events.push( 48 );
            }

            that.track( 'Thread social share', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:social-thread:' + channel + ':' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : events
            } );
        } );

        // Liking post
        $( '.kudos-link' ).click( function( e )
        {
            that.track( 'Liking a post', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:post:post-kudos:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Intent to share
        $( document ).on( 'click', '.lia-js-add-this-widget', function( e )
        {
            that.track( 'Intent to share', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:intent to share:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Related threads
        $( document ).on( 'click', '#recommended-content-comp .subject', function( e )
        {
            that.track( 'Related content', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:related thread:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Reply to thread intent
        $( '#pdc6_thread_reply_button' ).find( 'a' ).on( 'click', function()
        {
            that.track( 'Reply to thread intent', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:intent to reply to thread:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Reply to post intent
        $( '.lia-action-reply' ).on( 'click', function()
        {
            that.track( 'Reply to post intent', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:intent to reply:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Quote post intent
        $( '.quote-link' ).on( 'click', function()
        {
            that.track( 'Quote post intent', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:intent to quote:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Recommend intent
        $( '.recommend-via-mail' ).on( 'click', function()
        {
            that.track( 'Recommend intent', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:recommended thread:null:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        // Email Thread to Friend Intent
        $( '.lia-component-forums-action-email-message-to-friend' ).on( 'click', function()
        {
            that.track( 'Email Thread to Friend intent', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:email thread to friend:threadpage:' + that.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        } );

        var attachAjaxListener = function()
        {
            var s_ajaxListener = new Object();

            s_ajaxListener.tempOpen = XMLHttpRequest.prototype.open;
            s_ajaxListener.tempSend = XMLHttpRequest.prototype.send;
            s_ajaxListener.callback = function ()
            {
                // this.method : the ajax method used
                // this.url    : the url of the requested script (including query string, if any) (urlencoded)
                // this.data   : the data sent, if any ex: foo=bar&a=b (urlencoded)

                if( this.url == '/t5/forums/forumtopicpage.forummessageviewv2.quickreply.form.form.form' )
                {
                    trackQuickReply();
                }
            }

            XMLHttpRequest.prototype.open = function(a,b)
            {
                if (!a) var a='';
                if (!b) var b='';

                s_ajaxListener.tempOpen.apply(this, arguments);
                s_ajaxListener.method = a;
                s_ajaxListener.url = b;

                if (a.toLowerCase() == 'get')
                {
                    s_ajaxListener.data = b.split('?');
                    s_ajaxListener.data = s_ajaxListener.data[1];
                }
            }

            XMLHttpRequest.prototype.send = function(a,b)
            {
                if (!a) var a='';
                if (!b) var b='';

                s_ajaxListener.tempSend.apply(this, arguments);

                if(s_ajaxListener.method.toLowerCase() == 'post')s_ajaxListener.data = a;

                s_ajaxListener.callback();
            }
        };

        var trackQuickReply = function()
        {
            siteCat.track( 'Quick reply', {
                type   : siteCat.eventType.other,
                vars   : {
                    prop49 : 'button:quick reply:null:' + siteCat.pageName,
                    eVar49 : 'D=c49',
                    eVar20 : 'D=c20',
                    prop20 : prop20
                },
                events : baseEvents
            } );
        };

        attachAjaxListener();
    };

} )( jQuery );